<template>
  <v-container>
    <v-slide-x-transition group hide-on-leave>
      <v-row
        v-for="(question, index) in questions"
        :key="'Fill' + index"
        :class="!(index%2) ?'apply-back' :''"
      >
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            prepend-icon="mdi-delete"
            @click:prepend="onDelete(index)"
            :rules="[rules.required]"
            label="Sentence"
            v-model="question.content"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            :rules="[rules.required]"
            label="Answer"
            v-model="question.good_answer"
          />
        </v-col>
      </v-row>
    </v-slide-x-transition>
    <v-btn color="#FF347C" class="white--text mx-auto d-flex mt-4" depressed @click="onNew">
      <v-icon left>mdi-plus</v-icon>Add New
    </v-btn>
  </v-container>
</template>
<script>
import rulesMixin from '@/mixins/rulesMixin';
import crudMixin from '@/mixins/crudMixin';
import { postQuestions } from '@/api/api';

export default {
  mixins: [rulesMixin, crudMixin],
  props: {
    question_group: {
      required: false,
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      questions: [],
      defaultQuestion: () => ({
        title: 'Fill',
        content: '',
        good_answer: '',
      }),
    };
  },
  methods: {
    async save(uuid) {
      let question_group = {
        uuid,
        questions: this.questions,
      };
      try {
        const response = await postQuestions(question_group);
        this.questions = response.questions;
        return response;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
  },
  created() {
    if (this.question_group.questions) {
      this.questions = this.question_group.questions;
    } else this.questions.push(this.defaultQuestion());
  },
};
</script>
<style scoped>
.apply-back {
  background: #e0f6ff !important;
}
</style>